import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const hasProcessed = React.useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const session_id = match ? decodeURIComponent(match[1]) : null;
    if (!session_id) {
      navigate("/admin/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id });
        // Clear fragment from URL
        window.history.replaceState(null, "", window.location.pathname);
        await refresh();
        if (!data.is_admin) {
          toast.error("This email is not authorised for admin access.");
          navigate("/", { replace: true });
          return;
        }
        navigate("/admin", { replace: true, state: { user: data } });
      } catch (e) {
        toast.error("Could not complete sign-in.");
        navigate("/admin/login", { replace: true });
      }
    })();
  }, [navigate, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center">
        <div className="label-uppercase">Signing you in</div>
        <div className="mt-3 font-display text-2xl">One moment…</div>
      </div>
    </div>
  );
}
